{
  "version": 1,
  "asset_id": "d9f1a638-39e7-41be-b08c-3d6928f93d0a",
  "project_id": "f3267492-75a1-4be6-8d94-522819be8b81",
  "url": "/__l5e/assets-v1/d9f1a638-39e7-41be-b08c-3d6928f93d0a/erin.webp",
  "r2_key": "a/v1/f3267492-75a1-4be6-8d94-522819be8b81/d9f1a638-39e7-41be-b08c-3d6928f93d0a/erin.webp",
  "original_filename": "erin.webp",
  "size": 6366,
  "content_type": "image/webp",
  "created_at": "2026-07-17T17:22:08Z"
}
